import Accomodations from '~/js/views/resorts/components/Accomodations';
import '~/js/views/resorts/includes/scroll-below';


const internals = {
    filters: {
        roomCategories: ['RJ', 'P1', 'MS', 'UB', '1B', 'BB', 'HS']
    }
};

const reactAccomodations = document.querySelector('#rct-accomodations');

ReactDOM.render(<Accomodations filters={internals.filters} roomType="AT THE MILLIONAIRE SUITES" />, reactAccomodations);
